import { Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
	handleFilePicked,
	setAccessToken,
	setFiles,
	setSharePoint,
} from "../../redux/slices/contentSlice/onedriveContent/onedriveContent";
import { useDispatch } from "react-redux";
import { CloudUpload } from "@material-ui/icons";
import OneDriveAccountType from "./OneDriveAccountType";
import { handleManifestPreview } from "../../redux/slices/manifestPreviewSlice";

const params = {
	sdk: "8.0",
	entry: {
		oneDrive: {
			files: {},
		},
	},
	authentication: {},
	messaging: {
		origin: window.location.origin,
		channelId: "27",
	},
	typesAndSources: {
		mode: "all",
		pivots: {
			oneDrive: true,
			recent: true,
		},
	},
	selection: {
		mode: "multiple",
	},
};

const baseUrl = "https://onedrive.live.com/picker";

export default function OneDrivePicker({
	formik = { errors: {} },
	handleDisableButton,
}) {
	const [app, setApp] = useState(null);
	const [accType, setAccType] = React.useState("");
	const [isInitialized, setIsInitialized] = useState(false);
	const dispatch = useDispatch();
	const [selectedFiles, setSelectedFiles] = useState([]);

	const uploadFiles = async (commandData) => {
		let items = commandData.items;

		for (const data of items) {
			try {
				let token = await getToken();
				console.log(commandData, "cc");

				let url = `${data["@sharePoint.endpoint"]}/drives/${data.parentReference.driveId}/items/${data.id}`;

				if (data.folder) {
					url = `${data["@sharePoint.endpoint"]}/drives/${data.parentReference.driveId}/items/${data.id}/children`;
				}

				const headers = {
					Authorization: `Bearer ${token}`,
				};

				const response = await fetch(url, {
					method: "GET",
					headers,
				});

				const reader = response.body.getReader();
				const decoder = new TextDecoder("utf-8");
				let chunk = "";
				let result;

				while (!(result = await reader.read()).done) {
					chunk += decoder.decode(result.value, { stream: true });
				}

				const dataObj = JSON.parse(chunk);
				processSelectedFile(dataObj);
			} catch (err) {
				console.error("Error in uploadFiles:", err);
			}
		}
	};

	const processSelectedFile = (dataObj) => {
		if (dataObj.value) {
			setSelectedFiles(dataObj.value);
			dispatch(setFiles({ files: dataObj.value, type: "folder" }));
			dispatch(handleFilePicked(true));
			dispatch(handleManifestPreview({ contentSource: "onedrive" }));
		} else {
			setSelectedFiles((prevFiles) => [...prevFiles, dataObj]);
			dispatch(setFiles({ file: dataObj, type: "file" }));
			dispatch(handleFilePicked(true));
			dispatch(handleManifestPreview({ contentSource: "onedrive" }));
		}
	};

	useEffect(() => {
		if (accType) {
			const script = document.createElement("script");
			script.src =
				"https://alcdn.msauth.net/browser/2.19.0/js/msal-browser.min.js";
			script.async = true;

			script.onload = () => {
				try {
					const msalInstance =
						new window.msal.PublicClientApplication({
							auth: {
								authority: `https://login.microsoftonline.com/${accType}`,
								clientId:
									"d8ecd590-cb47-48dd-8774-a68c6d008d00",
								redirectUri: window.location.origin,
							},
						});
					setApp(msalInstance);
					setIsInitialized(true);
				} catch (error) {
					console.error("Error initializing MSAL:", error);
				}
			};

			script.onerror = (error) => {
				console.error("Error loading MSAL script:", error);
			};

			document.body.appendChild(script);

			return () => {
				document.body.removeChild(script);
			};
		}
	}, [accType]);

	let win = null;
	let port = null;

	async function launchPicker(e) {
		if (!isInitialized || !app) {
			console.error("MSAL not yet initialized");
			return;
		}

		try {
			const authToken = await getToken();
			if (!authToken) {
				console.error("Failed to get authentication token");
				return;
			}

			win = window.open("", "Picker", "height=600,width=1200");
			if (!win) {
				console.error("Failed to open picker window");
				return;
			}

			dispatch(setAccessToken(authToken));

			const queryString = new URLSearchParams({
				filePicker: JSON.stringify(params),
			});

			const url = `${baseUrl}?${queryString}`;

			const form = win.document.createElement("form");
			form.setAttribute("action", url);
			form.setAttribute("method", "POST");
			win.document.body.append(form);

			const input = win.document.createElement("input");
			input.setAttribute("type", "hidden");
			input.setAttribute("name", "access_token");
			input.setAttribute("value", authToken);
			form.appendChild(input);

			form.submit();

			window.addEventListener("message", handleMessage);
		} catch (error) {
			console.error("Error launching picker:", error);
			if (win) win.close();
		}
	}

	const handleMessage = (event) => {
		if (event.source && event.source === win) {
			const message = event.data;
			if (
				message.type === "initialize" &&
				message.channelId === params.messaging.channelId
			) {
				port = event.ports[0];
				port.addEventListener("message", messageListener);
				port.start();
				port.postMessage({
					type: "activate",
				});
			}
		}
	};

	async function messageListener(message) {
		switch (message.data.type) {
			case "notification":
				console.log(`notification: ${message.data}`);
				break;

			case "command":
				port.postMessage({
					type: "acknowledge",
					id: message.data.id,
				});

				const command = message.data.data;

				switch (command.command) {
					case "authenticate":
						const token = await getToken(command);

						if (typeof token !== "undefined" && token !== null) {
							port.postMessage({
								type: "result",
								id: message.data.id,
								data: {
									result: "token",
									token,
								},
							});
						} else {
							console.error(
								`Could not get auth token for command: ${JSON.stringify(
									command
								)}`
							);
						}
						break;

					case "close":
						win.close();
						break;

					case "pick":
						console.log(`Picked: ${JSON.stringify(command)}`);
						dispatch(
							setSharePoint(
								command.items[0]["@sharePoint.endpoint"]
							)
						);
						uploadFiles(command);

						port.postMessage({
							type: "result",
							id: message.data.id,
							data: {
								result: "success",
							},
						});

						win.close();
						break;

					default:
						console.warn(
							`Unsupported command: ${JSON.stringify(command)}`,
							2
						);
						port.postMessage({
							result: "error",
							error: {
								code: "unsupportedCommand",
								message: command.command,
							},
							isExpected: true,
						});
						break;
				}
				break;

			default:
				console.log(`Unhandled message type: ${message.data.type}`);
				break;
		}
	}

	async function getToken(command) {
		if (!app) {
			console.error("MSAL not initialized");
			return null;
		}

		let accessToken = "";
		let authParams = {
			scopes:
				accType === "common"
					? ["Files.ReadWrite.All"]
					: ["OneDrive.ReadWrite"],
		};

		try {
			// Try silent token acquisition first
			try {
				const resp = await app.acquireTokenSilent(authParams);
				accessToken = resp.accessToken;
			} catch (silentError) {
				// If silent token acquisition fails, try popup
				console.log(
					"Silent token acquisition failed, trying popup:",
					silentError
				);
				const loginResp = await app.loginPopup(authParams);
				if (loginResp) {
					app.setActiveAccount(loginResp.account);
					const tokenResp = await app.acquireTokenSilent(authParams);
					accessToken = tokenResp.accessToken;
				}
			}
			return accessToken;
		} catch (error) {
			console.error("Authentication error:", error);
			return null;
		}
	}

	return (
		<span id="original-tab-id">
			<OneDriveAccountType
				setAccType={setAccType}
				launchPicker={launchPicker}
				accType={accType}
				formik={formik}
				handleDisableButton={handleDisableButton}
			/>
		</span>
	);
}
